import React from 'react';
import { Send, Edit2, ArrowRight } from 'lucide-react';
export function LatestSimulation() {
  return <div className="bg-[#060c18] border border-[#0e1826] rounded-xl p-6 mt-6" data-id="element-33">
      <h2 className="text-lg font-bold text-[#f0ead8] mb-4" data-id="element-34">
        Latest simulation — Maria Rodriguez
      </h2>

      <div className="bg-[#04080f] border border-[#0e1826] rounded-lg p-4 flex items-center justify-between" data-id="element-35">
        {/* Left/Center Info */}
        <div className="flex items-center gap-6" data-id="element-36">
          {/* Thumbnail Placeholder */}
          <div className="w-24 h-24 rounded-md border border-[#b8a06a] bg-[#060c18] flex items-center justify-center overflow-hidden relative" data-id="element-37">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#b8a06a]/10 to-transparent" data-id="element-38"></div>
            <span className="text-[#3a5070] text-xs font-medium" data-id="element-39">3D Model</span>
          </div>

          <div className="flex flex-col justify-center" data-id="element-40">
            <h3 className="text-[#f0ead8] font-bold text-base mb-1" data-id="element-41">
              Implant 320cc round · Nipple 18cm
            </h3>
            <p className="text-[#3a5070] text-sm mb-4" data-id="element-42">
              Created 2h ago · 3 photos · Houston
            </p>

            {/* Progress Bar */}
            <div className="w-64 h-1.5 bg-[#0e1826] rounded-full overflow-hidden mb-4" data-id="element-43">
              <div className="h-full bg-[#b8a06a] w-[75%] rounded-full" data-id="element-44"></div>
            </div>

            {/* Actions */}
            <div className="flex items-center gap-3" data-id="element-45">
              <button className="bg-[#b8a06a] hover:bg-[#a38d5b] text-[#04080f] text-sm font-semibold py-1.5 px-4 rounded-md transition-colors flex items-center gap-2" data-id="element-46">
                <Send className="w-3.5 h-3.5" data-id="element-47" /> Send to patient
              </button>
              <button className="border border-[#0e1826] hover:bg-[#0e1826] text-[#f0ead8] text-sm font-medium py-1.5 px-4 rounded-md transition-colors flex items-center gap-2" data-id="element-48">
                <Edit2 className="w-3.5 h-3.5" data-id="element-49" /> Edit simulation
              </button>
              <button className="border border-[#0e1826] hover:bg-[#0e1826] text-[#f0ead8] text-sm font-medium py-1.5 px-4 rounded-md transition-colors flex items-center gap-2" data-id="element-50">
                <ArrowRight className="w-3.5 h-3.5" data-id="element-51" /> GHL contact
              </button>
            </div>
          </div>
        </div>

        {/* Right Stats */}
        <div className="flex flex-col items-end justify-center gap-4 border-l border-[#0e1826] pl-8 py-2" data-id="element-52">
          <div className="text-right" data-id="element-53">
            <span className="block text-[#3a5070] text-sm mb-1" data-id="element-54">
              Patient viewed
            </span>
            <div className="flex items-center gap-2 justify-end" data-id="element-55">
              <span className="text-[#4ac88a] font-bold" data-id="element-56">YES</span>
              <span className="bg-[#4ac88a]/10 text-[#4ac88a] text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-57">
                3×
              </span>
            </div>
          </div>
          <div className="text-right" data-id="element-58">
            <span className="block text-[#3a5070] text-sm mb-1" data-id="element-59">
              Last login
            </span>
            <span className="text-[#f0ead8] font-medium text-sm" data-id="element-60">
              Today 9:41am
            </span>
          </div>
        </div>
      </div>
    </div>;
}